import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Home sections
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import TechStack from './components/TechStack';
import Contact from './components/Contact';

// Pages
import PricingPage from './pages/PricingPage';
import BlogPage from './pages/BlogPage';
import DocsPage from './pages/DocsPage';

const HomePage = () => (
  <main>
    <Hero />
    <Features />
    <About />
    <TechStack />
    <Contact />
  </main>
);

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/docs" element={<DocsPage />} />
          {/* Fallback: redirect unknown routes to home */}
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;